var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', _vm._l(_vm.dictionaries.addressType, function (type, index) {
    return _c('v-col', {
      key: index,
      staticClass: "pa-0",
      attrs: {
        "cols": "12"
      }
    }, _vm._l(_vm.filteredAddresses(type), function (item, i) {
      return _c('v-col', {
        key: i
      }, [_c('AddressesComponent', {
        attrs: {
          "address": item
        },
        on: {
          "save-address": function saveAddress($event) {
            return _vm.saveAddresses($event, item);
          }
        }
      })], 1);
    }), 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }